// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-group {
  height: 34px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: white;
  text-align: center;
  white-space: nowrap;
  background-color: #36f;
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.input-group-text :hover {
  color: #36f;
  background-color: white;
  border: 1px solid #36f;
}

.input-group-text.disabled {
  background-color: #ccc;
  color: #666;
  cursor: not-allowed;
  border-color: #ccc;
}

.input-field {
  top: -23px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
  max-width: 100%;
  table-layout: auto;
  align-items: center;
  justify-content: center;
}

.table-responsive {
  justify-content: center;
  align-items: center;
}

.custom-table thead {
  color: white;
  font-weight: 700;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 13px 10px !important;
}

th,
td {
  padding: 13px 10px !important;
  border: 1px solid #ddd;
  text-align: left;
  text-decoration: none;
}

th {
  position: sticky;
  top: 0;
  background-color: #95a2b1;
  color: white !important;
}

.agentReviewApplndata {
  display: flex;
  background: linear-gradient(135deg, #498bef, #a9b9ef);
  color: white;
  font-weight: bold;
  font-size: 1rem;
  height: 45px;
  align-items: center;
  padding: 0 1rem;
  gap: 2rem;
  overflow-x: auto;
}
.agentReviewApplndata .info-pair {
  display: flex;
  min-width: -moz-fit-content;
  min-width: fit-content;
  font-weight: 200;
}
.agentReviewApplndata .info-pair label {
  font-size: 1rem;
  margin-right: 0.4rem;
  white-space: nowrap;
  color: #fff;
}
.agentReviewApplndata .info-pair span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #f1cf4d;
}

@media only screen and (max-width: 1024px) {
  .headerData {
    margin-top: 0px;
  }
}
.success {
  color: #0cb452;
  font-size: 1.5rem !important;
  margin-right: 10px !important;
}

/* Select box Css */
::ng-deep .custom-ng-select {
  max-width: 400px;
  width: 100%;
}

::ng-deep .custom-ng-select .ng-value {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::ng-deep .custom-ng-select .ng-value-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.advanceSearch {
  z-index: 100;
  min-width: 600px;
  max-height: 350px;
  right: 0;
  background-color: white;
  overflow: hidden;
}

.advanceSearch-body {
  overflow-y: auto;
  height: auto;
}

.note-details {
  background-color: #36f;
  color: #fff;
}

.note-details:hover {
  color: #fff;
  border-color: #598bff;
  background-color: #598bff;
}

.modal-footer-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.row {
  --bs-gutter-x: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/gamification/gamification-request/gamification-request.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,6BAAA;AACF;;AAEA;;EAEE,6BAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,qDAAA;EAEA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAAF;AAEE;EACE,aAAA;EACA,2BAAA;EAAA,sBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAAN;AAGI;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AADN;;AAWA;EACE;IACE,eAAA;EARF;AACF;AAWA;EACE,cAAA;EACA,4BAAA;EACA,6BAAA;AATF;;AAYA,mBAAA;AACA;EACE,gBAAA;EACA,WAAA;AATF;;AAYA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AATF;;AAYA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AATF;;AAYA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;EACA,uBAAA;EACA,gBAAA;AATF;;AAYA;EACE,gBAAA;EACA,YAAA;AATF;;AAYA;EACE,sBAAA;EACA,WAAA;AATF;;AAYA;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AATF;;AAYA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AATF;;AAYA;EACE,qBAAA;AATF","sourcesContent":[".input-group {\n  height: 34px;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: white;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #36f;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n}\n\n.input-group-text :hover {\n  color: #36f;\n  background-color: white;\n  border: 1px solid #36f;\n}\n\n.input-group-text.disabled {\n  background-color: #ccc;\n  color: #666;\n  cursor: not-allowed;\n  border-color: #ccc;\n}\n\n.input-field {\n  top: -23px;\n}\n\n.custom-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 600px;\n  max-width: 100%;\n  table-layout: auto;\n  align-items: center;\n  justify-content: center;\n}\n\n.table-responsive {\n  justify-content: center;\n  align-items: center;\n}\n\n.custom-table thead {\n  color: white;\n  font-weight: 700;\n  text-align: left;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  padding: 13px 10px !important;\n}\n\nth,\ntd {\n  padding: 13px 10px !important;\n  border: 1px solid #ddd;\n  text-align: left;\n  text-decoration: none;\n}\n\nth {\n  position: sticky;\n  top: 0;\n  background-color: #95a2b1;\n  color: white !important;\n}\n\n.agentReviewApplndata {\n  display: flex;\n  background: linear-gradient(135deg, #498bef, #a9b9ef);\n  // border: 3px solid #f1cf4d;\n  color: white;\n  font-weight: bold;\n  font-size: 1rem;\n  height: 45px;\n  align-items: center;\n  padding: 0 1rem;\n  gap: 2rem;\n  overflow-x: auto;\n\n  .info-pair {\n    display: flex;\n    min-width: fit-content;\n    font-weight: 200;\n\n    label {\n      font-size: 1rem;\n      margin-right: 0.4rem;\n      white-space: nowrap;\n      color: #fff;\n    }\n\n    span {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      color: #f1cf4d;\n    }\n  }\n}\n\n// .headerData {\n//   margin-top: -40px;\n// }\n\n// Added CSS fro the headerdata is overlapping with breadcrumblist\n@media only screen and (max-width: 1024px) {\n  .headerData {\n    margin-top: 0px;\n  }\n}\n\n.success {\n  color: #0cb452;\n  font-size: 1.5rem !important;\n  margin-right: 10px !important;\n}\n\n/* Select box Css */\n::ng-deep .custom-ng-select {\n  max-width: 400px;\n  width: 100%;\n}\n\n::ng-deep .custom-ng-select .ng-value {\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n::ng-deep .custom-ng-select .ng-value-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.advanceSearch {\n  z-index: 100;\n  min-width: 600px;\n  max-height: 350px;\n  right: 0;\n  background-color: white;\n  overflow: hidden;\n}\n\n.advanceSearch-body {\n  overflow-y: auto;\n  height: auto;\n}\n\n.note-details {\n  background-color: #36f;\n  color: #fff;\n}\n\n.note-details:hover {\n  color: #fff;\n  border-color: #598bff;\n  background-color: #598bff;\n}\n\n.modal-footer-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.row {\n  --bs-gutter-x: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
